import React, {Component} from 'react';

import {css} from 'aphrodite/no-important';
import styles from './EventList.styles';
import {format} from 'date-fns';

const DOWN = 40;
const UP = 38;
const ROW_HEIGHT=50;


function resizeList(){
  let n = document.getElementById('event-list');
  if(n.style === 'none'){
    return;
  }
  let listh = n.getBoundingClientRect().height;
  let parent = n.parentElement;
  let box = parent.getBoundingClientRect();
  let h = box.height;
  let rowh = 40;
  let rowsh= n.childElementCount * rowh;
  let diffh = h - 100;
  if(rowsh <= listh && listh <= diffh){
    return;
  }
  if(rowsh < diffh){
    n.style.height = rowsh + 'px';
  }else{
    n.style.height = diffh + 'px';
  }
}

function resizeWithParent(list){
  resizeList();
}

class EventList extends Component {
  constructor(props){
    super(props);
    this.state = {current: false, clicked: false}
    this.eldiv = React.createRef();
    this.obs = new MutationObserver(resizeWithParent);
  }
  componentDidMount(){
    let m = document.getElementById(this.props.containerId);
    this.obs.observe(m, {attributes: true});
  }
  componentWillUnmount(){
    this.obs.disconnect();
  }

  componentDidUpdate(prev){
    if(this.props.data.length !== prev.data.length){
      let n = this.eldiv.current;
      if(this.props.data.length === 0){
        n.style.display = 'none';
      }else{
        let parent = n.parentElement;
        let box = parent.getBoundingClientRect();
        let h = box.height;
        let rowh = 40;
        let rowsh = this.props.data.length * rowh;
        let diffh = h - 100;
        n.style.display = 'block';
        if(rowsh < diffh){
          //nothing dom wil do it;
          return
        } 
        n.style.height = diffh + 'px';
      }
    }
    if(this.props.currentTag !== prev.currentTag){
      if(this.state.current !== this.props.currentTag){
        this.setState({current: this.props.currentTag, clicked: false});
      }
    }
  }
  clickHander(idx, d, clicked){
    if(this.props.onClick){
      this.props.onClick(idx,d);
    }
    this.setState({current: idx, clicked: (clicked === false) ? false : true});
  }
  
  renderEvents(data) {
    return data.map((d,idx) => {
      let ct = this.state.current;
      let selected = ct === idx;
      let s = [styles.item, styles.itemhover];
      if(selected){
        s.push(styles.itemactive);
      }
      let t = [format(new Date(d.d), 'MM/DD/YYYY HH:mm')];
      if(d.cont){
        t.push(format(new Date(d.cont),'to MM/DD/YYYY HH:mm'));
      }
    return ( <div key={idx} selected={selected} className={css(...s)} onClick={this.clickHander.bind(this,idx, d)}> 
      {t.map(i=><div key={idx + i + Math.random()}>{i}</div>)} 
    </div>)
    })
  }

  moveScroll(keyCode){
    if(this.state.clicked){
      return;
    }
    if(!keyCode){
      //using playback, set to down
      keyCode = DOWN;
    }
    let n = this.eldiv.current;
    let box = n.getBoundingClientRect();
    let visiblerows = Math.floor(box.height/ROW_HEIGHT);
    if(this.state.current > Math.floor(visiblerows/2)){
      if(keyCode === DOWN){
        n.scrollTop = this.state.current * ROW_HEIGHT;  
      }else{
        n.scrollTop = (this.state.current -1)  * ROW_HEIGHT;  
      }
    }
  }

  handleKeyDown(data, e){
    this.moveScroll(e.keyCode);
    let i = (e.keyCode === DOWN) ?  1 : (e.keyCode === UP) ? -1 : 0; 
    let c = this.state.current;
    let idx = c + i;
    if(idx < 0 || idx > this.props.data.length-1){
      return;
    }
    if(idx !== c){
      let d = data[idx];
      this.clickHander(idx, d, false);
    }
  }


  render(){
    let data = this.props.data || [];
    if(this.state.current > 2){
      this.moveScroll();
    }
    return ( <div ref={this.eldiv} id="event-list" tabIndex="1" className = {css(styles.list)} onKeyDown={this.handleKeyDown.bind(this, data)}> {
      this.renderEvents(data)
    } </div>)
  }
  
}

export default EventList;


// WEBPACK FOOTER //
// ./src/components/data/historymap/EventList.js